import gql from 'graphql-tag';

export const ALL_PUBLISHED_POSTS = gql`
  query GetAllPublishedPosts($searchString: String, $limit: Int, $from: Int, $sortBy: String, $order: String, $is_featured: Boolean, $is_tycoon: Boolean, $category: String, $author_id: ID) {
    allPublishedPosts(searchString: $searchString, limit: $limit, from: $from, sortBy: $sortBy, order: $order) {
      post_id
      title
      category
      publish_date
      amount(is_featured: $is_featured, is_tycoon: $is_tycoon, published: true, category: $category, author_id: $author_id)
    }
  }
`;

export const ALL_PUBLISHED_POSTS_BY_CATEGORY = gql`
  query GetAllPublishedPostsByCategory($searchString: String, $limit: Int, $from: Int, $sortBy: String, $order: String, $is_featured: Boolean, $is_tycoon: Boolean, $published: Boolean, $category: String, $author_id: ID) {
    allPublishedPostsByCategory(searchString: $searchString, limit: $limit, from: $from, sortBy: $sortBy, order: $order, category: $category) {
      post_id
      title
      category
      publish_date
      amount(is_featured: $is_featured, is_tycoon: $is_tycoon, published: $published, category: $category, author_id: $author_id)
    }
  }
`;

export const ALL_PUBLISHED_POSTS_BY_AUTHOR_ID = gql`
  query GetAllPublishedPostsByAuthorId($searchString: String, $limit: Int, $from: Int, $sortBy: String, $order: String, $is_featured: Boolean, $is_tycoon: Boolean, $published: Boolean, $category: String, $author_id: ID) {
    allPublishedPostsByAuthorId(searchString: $searchString, limit: $limit, from: $from, sortBy: $sortBy, order: $order, category: $category, author_id: $author_id) {
      post_id
      title
      category
      publish_date
      amount(is_featured: $is_featured, is_tycoon: $is_tycoon, published: $published, category: $category, author_id: $author_id)
    }
  }
`;
